import { render, staticRenderFns } from "./CollapsibleHelpQuestion.vue?vue&type=template&id=51a93171&scoped=true"
import script from "./CollapsibleHelpQuestion.vue?vue&type=script&lang=js"
export * from "./CollapsibleHelpQuestion.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleHelpQuestion.vue?vue&type=style&index=0&id=51a93171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a93171",
  null
  
)

export default component.exports